<div id="products-container">
  @if (!!products) {
  <span class="container">
    <span class="products">
      {{ products }}
    </span>
  </span>
  }
</div>
